const fromPairs = (arr) => arr.reduce((acc, val) => (acc[val[0]] = val[1], acc), {});

export default fromPairs;
